<template>
    <ui-report-panel title="Estimates" :filters="filters" :fetch="fetch" @filtersChanged="({ refresh }) => refresh()">
        <template #actions="{ report }">
            <div class="flex items-baseline space-x-6">
                <div>
                    <span class="relative inline-flex rounded-full h-2 w-2 bg-blue-500"></span>
                    <span class="text-xs font-semibold text-gray-500">Viewed</span>
                </div>
                <div>
                    <span class="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
                    <span class="text-xs font-semibold text-gray-500">Accepted</span>
                </div>
                <div>
                    <span class="relative inline-flex rounded-full h-2 w-2 bg-red-500"></span>
                    <span class="text-xs font-semibold text-gray-500">Declined</span>
                </div>
                <span class="text-xs font-semibold text-gray-500">{{ report.length }} Sent</span>
            </div>
        </template>
        <template #default="{ report }">
            <ui-table v-if="report && report.length > 0"
                      :headers="['', 'Reference', 'Package', 'Date', 'From','To','Sub-Total','Markup','Estimated Profit','Total']"
                      v-slot="{ cellClass }" compact>
                <tr v-for="remoteFile in parseReport(report, filters)"
                    :key="`${remoteFile.id}-${remoteFile.closed_at ? 'closed' : 'opened'}`"
                    class="hover:bg-blue-50 cursor-pointer" @click="goTo(remoteFile.entity._links.show)">
                    <td :class="cellClass" @click="$event.stopPropagation()">
                        <input
                            type="checkbox"
                            class="h-4 w-4 rounded text-blue-500 border-gray-500 focus:border-blue-400 focus:ring-offset-0 focus:ring focus:ring-blue-300 focus:ring-opacity-50 transition"
                            :value="remoteFile.id"
                            v-model="selectedInviteIds"
                            @click="$event.stopPropagation()"
                        >
                    </td>
                    <td :class="cellClass">
                        <reports-sent-estimates-status-dot class="mr-2"
                                                           :remote-file="remoteFile"></reports-sent-estimates-status-dot>
                        {{ remoteFile.entity.reference }}
                    </td>
                    <td :class="cellClass" class="font-medium text-gray-900">
                    <span class="truncate">
                      {{ remoteFile.entity.full_package_name | truncate(40) }}
                    </span>
                    </td>
                    <td :class="cellClass">
                        {{ remoteFile.emailed_at }}
                    </td>
                    <td :class="cellClass">
                        {{ remoteFile.invited_by }}
                    </td>
                    <td :class="cellClass">
                  <span class="truncate">
                    {{ remoteFile.email | truncate(20) }}
                  </span>
                    </td>
                    <td :class="cellClass" class="text-right">
                        &pound;{{ remoteFile.entity.total | toCurrency(false) }}
                    </td>
                    <td :class="cellClass" class="text-right">
                        {{ remoteFile.entity.markup_pc | toCurrency(false) }}%
                    </td>
                    <td :class="cellClass" class="text-right">
                        &pound;{{ remoteFile.entity.estimated_profit | toCurrency(false) }}
                    </td>
                    <td :class="cellClass" class="text-right">
                        &pound;{{ remoteFile.entity.cf_total | toCurrency(false) }}
                    </td>
                </tr>
            </ui-table>
            <div v-else class="px-4 py-16 text-center text-gray-400">
                There has been no sent estimates within the parameters you searched for...
            </div>
        </template>
    </ui-report-panel>
</template>

<script>
import {RemoteInvite} from '@models'
import ReportsSentEstimatesStatusDot from "./ReportsSentEstimatesStatusDot";
import SentEstimate from "../../../models/Reporting/SentEstimate";
import moment from "moment";

export default {
    components: {ReportsSentEstimatesStatusDot},
    props: {
        filters: Object,
        parseReport: Function,
    },
    data() {
        return {
            invites: [],
            selectedInviteIds: [],
        }
    },
    computed: {
        selectedInvites() {
            return this.invites.filter(({id}) => this.selectedInviteIds.includes(id))
        },
    },
    methods: {
        async fetch(filters) {
            let invites
            await Promise.all([
                RemoteInvite.allWithActivity({...filters, type: 'estimate'}),
                SentEstimate.all(moment(filters.from).startOf('day').format(), moment(filters.to).endOf('day').format(), filters.estimator ? filters.estimator.value : null)
            ]).then((a) => {
                invites = a[0]?a[0]:[];
                //TODO - remove this hack once we re-engineer the reports
                (a[1]?a[1]:[]).forEach((s) => {
                    invites.unshift({
                        'accepted': false,
                        'cc': false,
                        'declined': false,
                        'email': s.sentTo,
                        'emailed_at': s.sentAt,
                        'entity': {
                            '_links': {
                                'show': route('mobile.estimation.packages.estimates', [s.packageReference,s.estimateId]),
                            },
                            'estimated_profit': s.value - s.cost,
                            'full_package_name': s.packageName,
                            'reference': s.packageReference + ' - ' + s.reference,
                            'viewed_by_remote_recipient': s.viewedAt ? true : false,
                            'cf_amount': s.value,
                            'cf_total': s.value,
                            'total': s.cost,
                            'markup_pc': Math.round((s.value - s.cost) / s.cost * 10000) / 100
                        },
                        'expired': false,
                        'id': s.id,
                        'invited_by': s.sentByName,
                        'revoked': false,
                        'token_expires': false,
                        'token_expires_human': false,
                        'view_records': false,
                        'viewed': s.viewedAt ? true : false,
                        'viewed_at': s.viewedAt ? s.viewedAt : false,
                        'viewed_ip': false,
                    })
                })
            })
            this.invites = invites
            this.selectedInviteIds = invites.map(({id}) => id)
            return invites
        },
        goTo(url) {
            window.location = url
        },
    },
    watch: {
        selectedInvites(invites) {
            this.$emit('update:count', invites.length)
            this.$emit('update:sum', invites.reduce((acc, invite) => acc + invite.entity.cf_total, 0))
        },
    }
}
</script>
